__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "career-frontend";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.6.9", function() { return __webpack_require__.e(10).then(function() { return function() { return __webpack_require__(732); }; }); });
			register("@datadog/browser-rum", "4.45.0", function() { return __webpack_require__.e(16).then(function() { return function() { return __webpack_require__(734); }; }); });
			register("@guildeducationinc/auth-frontend-tools", "15.3.2", function() { return __webpack_require__.e(14).then(function() { return function() { return __webpack_require__(735); }; }); });
			register("@guildeducationinc/mfe-utils", "2.1.4", function() { return __webpack_require__.e(5).then(function() { return function() { return __webpack_require__(1002); }; }); });
			register("@guildeducationinc/playground-mx", "1.2.1", function() { return __webpack_require__.e(8).then(function() { return function() { return __webpack_require__(1270); }; }); });
			register("@guildeducationinc/recess", "10.33.1", function() { return __webpack_require__.e(6).then(function() { return function() { return __webpack_require__(1279); }; }); });
			register("@guildeducationinc/type-guards", "1.1.0", function() { return __webpack_require__.e(19).then(function() { return function() { return __webpack_require__(1423); }; }); });
			register("@optimizely/react-sdk", "2.7.0", function() { return __webpack_require__.e(13).then(function() { return function() { return __webpack_require__(1424); }; }); });
			register("@webiny/react-rich-text-renderer", "5.35.0", function() { return __webpack_require__.e(12).then(function() { return function() { return __webpack_require__(1460); }; }); });
			register("classnames", "2.3.2", function() { return __webpack_require__.e(20).then(function() { return function() { return __webpack_require__(1462); }; }); });
			register("graphql-tag", "2.12.6", function() { return __webpack_require__.e(11).then(function() { return function() { return __webpack_require__(1463); }; }); });
			register("graphql", "16.5.0", function() { return __webpack_require__.e(21).then(function() { return function() { return __webpack_require__(1464); }; }); });
			register("history", "5.3.0", function() { return __webpack_require__.e(18).then(function() { return function() { return __webpack_require__(1465); }; }); });
			register("lodash", "4.17.21", function() { return __webpack_require__.e(22).then(function() { return function() { return __webpack_require__(1466); }; }); });
			register("react-calendly", "4.1.1", function() { return __webpack_require__.e(7).then(function() { return function() { return __webpack_require__(1467); }; }); });
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(533); }; }, 1);
			register("react-router-dom", "6.3.0", function() { return __webpack_require__.e(9).then(function() { return function() { return __webpack_require__(1468); }; }); });
			register("react-router", "6.3.0", function() { return __webpack_require__.e(15).then(function() { return function() { return __webpack_require__(1469); }; }); });
			register("react", "17.0.2", function() { return function() { return __webpack_require__(536); }; }, 1);
			register("usehooks-ts", "2.9.1", function() { return __webpack_require__.e(23).then(function() { return function() { return __webpack_require__(1470); }; }); });
			register("video.js", "7.20.3", function() { return __webpack_require__.e(17).then(function() { return function() { return __webpack_require__(1471); }; }); });
			initExternal(1496);
			initExternal(1498);
			initExternal(2453);
			initExternal(2455);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};